import { Alert } from '@mui/material'
import { useOrderStore } from 'modules/orders/store'

export const RecalculeAlert = () => {
  const isTaxesRecalculePending = useOrderStore.useIsTaxesRecalculePending()

  if (!isTaxesRecalculePending) return null

  return (
    <div
      style={{
        width: '100%'
      }}
    >
      <Alert severity="error">Recálculo de imposto pendente</Alert>
    </div>
  )
}
